import { Container, Title, Text, Button, Group, rem } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchUserAttributes } from 'aws-amplify/auth';
import * as Sentry from '@sentry/browser';
import classes from './error-page-general.module.css';
import { useEffect } from 'react';

function ErrorPageGeneral({ error }: { error: Error }) {
  const { user } = useAuthenticator((context) => [context.user]);

  // TODO: Add user attributes to Sentry
  useEffect(() => {
    if (user) {
      fetchUserAttributes()
        .then((userAttributes) => {
          Sentry.setUser({
            id: `${user.userId}`,
            username: `${userAttributes?.given_name} ${userAttributes?.family_name}`,
            email: `${userAttributes?.email}`,
          });
        })
        .catch((error) => {
          console.log('error: ', error);
          Sentry.setUser(null);
        });
    }
  }, [user]);

  console.error('ErrorPageGeneral: ', error);
  Sentry.captureException(error, { extra: { error } });

  return (
    <Container className={classes.root}>
      <div className={classes.inner}>
        <div className={classes.label}>oops...</div>
        <div className={classes.content}>
          <Title className={classes.title}>Thats unexpected.</Title>
          <Text c="dimmed" size="lg" ta="center" className={classes.description}>
            Sorry, this is not the result we expected. Please don't worry; our development team has already
            been notified.
          </Text>
          <Group justify="center">
            <Button size="md" component={Link} to="/get-started">
              Please try again
            </Button>
          </Group>
        </div>
      </div>
      {import.meta.env.MODE !== 'production' && (
        <Text c="gray.4" size="sm" ta="right" mt={rem(30)}>
          {error.message}
        </Text>
      )}
    </Container>
  );
}

export default ErrorPageGeneral;
